var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-gray container-fix-padding", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { attrs: { lg: "12" } },
        [
          _c("v-breadcrumbs", {
            staticClass: "p-0",
            attrs: { items: _vm.breadcrumbs },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "v-col",
            {
              staticClass: "bg-white ms-3",
              class: { "me-3": _vm.mobile },
              attrs: { lg: "8" },
            },
            [
              _c(
                "div",
                { staticClass: "question-menu bm-3 d-flex" },
                [
                  _c(
                    "v-col",
                    { attrs: { lg: "10" } },
                    [
                      _c(
                        "v-tabs",
                        [
                          _c("v-tab", [_vm._v("マイ質問")]),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { attrs: { to: "/classroom/questions" } },
                            [_vm._v("みんなの質問")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            { attrs: { to: "/classroom/my-answer-questions" } },
                            [_vm._v("アンサーした質問")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.mobile
                    ? _c(
                        "v-col",
                        {
                          staticClass: "text-end text-end p-0 pe-2",
                          attrs: { lg: "2" },
                        },
                        [_c("UserQuestionDialog")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "search-form" },
                        [
                          _c("v-combobox", {
                            attrs: {
                              "search-input": _vm.search,
                              placeholder: "入力してください",
                              "prepend-icon": "mdi-database-search",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.search = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.search = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "me-2 mt-7 search-test",
                          on: {
                            click: function ($event) {
                              _vm.search = ""
                            },
                          },
                        },
                        [_vm._v("クリア")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoading
                ? _vm._l(Array.from(Array(10).keys()), function (item, index) {
                    return _c("v-skeleton-loader", {
                      key: index,
                      ref: "skeleton",
                      refInFor: true,
                      staticClass: "mx-auto",
                      attrs: { type: "list-item-avatar-three-line" },
                    })
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.questions, function (question) {
                return [
                  _c(
                    "v-list-item",
                    {
                      key: "question-" + question.id,
                      staticClass: "ps-0",
                      attrs: { to: "/classroom/questions/" + question.id },
                    },
                    [
                      _c("v-list-item-icon", [
                        _c("div", { staticClass: "question-box" }, [
                          _c("div", { staticClass: "question-num" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(question.answersCount) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: {
                                "question-active": question.answersCount > 0,
                                "question-deactive": question.answersCount == 0,
                              },
                            },
                            [_vm._v("\n                Ans\n              ")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(question.title)),
                            question.questionType == "private_question"
                              ? _c(
                                  "span",
                                  { staticClass: "private-question" },
                                  [_vm._v("（プライベート質問）")]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("v-list-item-subtitle", [
                            question.createdAt
                              ? _c("span", { staticClass: "me-2" }, [
                                  _vm._v(
                                    _vm._s(question.createdAt.substring(0, 10))
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "me-2" },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("thumb_up"),
                                ]),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(question.voteValues) +
                                    "\n              "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            question.user && question.user.image
                              ? _c("img", {
                                  staticStyle: { width: "15px" },
                                  attrs: { src: question.user.image.url },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            question.user && question.user.name
                              ? _c("span", [_vm._v(_vm._s(question.user.name))])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider", { key: "divider-" + question.id }),
                ]
              }),
              _vm._v(" "),
              _vm.questions.length > 0
                ? _c("v-pagination", {
                    staticClass: "mt-4 mb-5",
                    attrs: { length: _vm.pagination.totalPages },
                    on: { input: _vm.selectPage },
                    model: {
                      value: _vm.pagination.page,
                      callback: function ($$v) {
                        _vm.$set(_vm.pagination, "page", $$v)
                      },
                      expression: "pagination.page",
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.mobile
        ? _c("v-footer", { attrs: { fixed: true } }, [
            _c(
              "div",
              {
                staticClass: "d-flex",
                attrs: { justify: "center", "no-gutters": "" },
              },
              [
                _c(
                  "v-col",
                  { staticClass: "text-center", attrs: { cols: "12" } },
                  [_c("UserQuestionDialog")],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }